import { FormEvent, useState } from 'react';
import { cancelButtonStyle, editIconStyle, saveButtonStyle } from '../../style';

import { Button, Dialog, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SupportInformation } from '../../lib/models/SupportModels';
import { useScreenSmallerThan } from '../../lib/hooks/breakpoint-hooks';
import { StyledDialogActions } from '../../styledComponents';

interface AvailabilityInfoDto {
    availability: string;
    type: string;
    id: string;
    onUpsertAvailability: (event: FormEvent, availability: SupportInformation) => void;
}

const AvailabilityModal = (props: AvailabilityInfoDto) => {
    const { availability, type, id, onUpsertAvailability } = props;

    const title = 'Availability';
    const [isDialogOpened, setDialogOpened] = useState(false);
    const [availabilityValue, setAvailabilityValue] = useState(availability);

    const handleOpenDialog = () => setDialogOpened(true);
    const handleCloseDialog = () => setDialogOpened(false);

    const isSmallerThanSmall = useScreenSmallerThan('sm');

    const handleSave = async (event: FormEvent) => {
        event.preventDefault();
        const availabilityUpdate: SupportInformation = {
            id: id,
            type: type,
            availability: availabilityValue,
            supportContact: []
        };

        onUpsertAvailability(event, availabilityUpdate);

        //Close Dialog window
        setDialogOpened(false);
    };

    return (
        <div>
            <IconButton aria-label="edit" onClick={handleOpenDialog}>
                <EditOutlinedIcon sx={editIconStyle} />
            </IconButton>
            <Dialog open={isDialogOpened} onClose={handleCloseDialog}>
                <DialogTitle variant="h3">{title}</DialogTitle>
                <form onSubmit={handleSave}>
                    <DialogContent>
                        <TextField
                            sx={{ width: isSmallerThanSmall ? '15.625rem' : '25rem' }}
                            required
                            label="Available hours"
                            type="text"
                            inputProps={{ inputMode: 'text' }}
                            value={availabilityValue}
                            onChange={(v) => setAvailabilityValue(v.target.value)}
                        />
                    </DialogContent>
                    <StyledDialogActions sx={{ paddingRight: '1.5rem', paddingLeft: '1.5rem' }}>
                        <Button sx={cancelButtonStyle} onClick={handleCloseDialog}>
                            Cancel
                        </Button>
                        <Button sx={saveButtonStyle} type="submit">
                            Save
                        </Button>
                    </StyledDialogActions>
                </form>
            </Dialog>
        </div>
    );
};

export default AvailabilityModal;
